module.exports = __webpack_public_path__ + "img/BR.aa1e61da.svg";